import { JsonObject, JsonProperty } from 'json2typescript';
import { LawyerTiny } from '../lawyers/lawyer';
import { Service } from '../services/service';

export enum ExpenseTypeEnum {
    DISBURSEMENTS = 1,
    'THIRD PARTY FEES' = 2,
    'THIRD PARTY DISBURSEMENTS' = 3
}

export enum EntryState {
    ENTERED = 1,
    INVOICED = 2,
    PAID = 3
}

@JsonObject('EntryBase')
export class EntryBase {
    @JsonProperty('id', Number, true)
    id: number = undefined;

    @JsonProperty('case_id', Number, true)
    caseId: number = undefined;

    @JsonProperty('timesheet', Number, true)
    timesheet: number = undefined;

    @JsonProperty('case_number', String, true)
    caseNumber: number = undefined;

    @JsonProperty('description', String, true)
    description = null;

    @JsonProperty('state', Number, true)
    state: number = undefined;

    @JsonProperty('date', String, true)
    date = null;

    @JsonProperty('created_date', String, true)
    createdDate = null;

    get stateString() {
        return EntryState[this.state];
    }

    get isInvoiced() {
        return this.state === EntryState.INVOICED;
    }

    get isPaid() {
        return this.state === EntryState.PAID;
    }
}

@JsonObject('TimesheetEntry')
export class TimesheetEntry extends EntryBase {
    @JsonProperty('lawyer', LawyerTiny, true)
    lawyer: LawyerTiny = undefined;

    @JsonProperty('lawyer_id', Number, true)
    lawyerId: number = undefined;

    @JsonProperty('hours', Number, true)
    hours: number = undefined;

    @JsonProperty('amount', Number, true)
    amount: number = undefined;

    @JsonProperty('service', Number, true)
    service: number = undefined;

    @JsonProperty('service_name', String, true)
    serviceName = null;

    @JsonProperty('service_data', Service, true)
    serviceData: Service = null;

    @JsonProperty('billable', Boolean, true)
    billable = true;

    get rate() {
        return Math.round(this.amount / this.hours);
    }
}

@JsonObject('TimesheetExpense')
export class TimesheetExpense extends EntryBase {
    @JsonProperty('lawyer', LawyerTiny, true)
    lawyer: LawyerTiny = undefined;

    @JsonProperty('lawyer_id', Number, true)
    lawyerId: number = undefined;

    @JsonProperty('expense_type', Number, true)
    expenseType: ExpenseTypeEnum = undefined;

    @JsonProperty('amount', Number, true)
    amount: number = undefined;

    @JsonProperty('name', String, true)
    name: string = null;

    get expenseTypeStr() {
        return ExpenseTypeEnum[this.expenseType];
    }
}